import React from 'react';
import PropTypes from 'prop-types';
import { Label as StyledLabel } from './style';
import colors from '../../../../config/colors.json';

const Label = ({
    id,
    children,
    theme,
    marginBottom,
    fontSize,
    lineHeight,
    fontWeight,
    color,
 }) => (
	<StyledLabel
		theme={theme}
		htmlFor={id}
		marginBottom={marginBottom}
		fontSize={fontSize}
		lineHeight={lineHeight}
		color={color}
		fontWeight={fontWeight}
	>
		{ children }
	</StyledLabel>
);

Label.defaultProps = {
    id: '',
    children: null,
    theme: '',
    marginBottom: '10px',
    fontSize: '14px',
    lineHeight: '21px',
    fontWeight: 600,
    color: colors.dark,
};

PropTypes.Label = {
    id: PropTypes.string,
    children: PropTypes.elements,
    theme: PropTypes.string,
    marginBottom: PropTypes.string,
    fontSize: PropTypes.string,
    lineHeight: PropTypes.string,
    fontWeight: PropTypes.number,
    color: PropTypes.string,
};

export default Label;
